/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEcommContentTemplate1Data } from './ecomm-content-template-1.data';
import { IEcommContentTemplate1Props } from './ecomm-content-template-1.props.autogenerated';

export interface IEcommContentTemplate1ViewProps extends IEcommContentTemplate1Props<IEcommContentTemplate1Data> {
    description: React.ReactNode;
}

/**
 *
 * EcommContentTemplate1 component
 * @extends {React.PureComponent<IEcommContentTemplate1Props<IEcommContentTemplate1Data>>}
 */
class EcommContentTemplate1 extends React.PureComponent<IEcommContentTemplate1Props<IEcommContentTemplate1Data>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const text = config.description && (
            <MsDyn365.RichTextComponent
                text={config.description}
                editProps={{
                    onEdit: this._handleTextChange,
                    requestContext: this.props.context.request
                }}
            />
        );

        const EcommContentTemplateViewProps = {
            ...this.props,
            description: text
        };

        return this.props.renderView(EcommContentTemplateViewProps);
    }

    private _handleTextChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.description = event.target.value);
}

export default EcommContentTemplate1;
